import React, { useContext } from 'react'
import { AdminAccordionItem } from './AdminAccordionItem';
import { VehicleContext } from '../Context/VehicleContext';

const Dashboard = () => {
  const {getVehicleData, filteredVehicleData, searchText, setSearchText, numberFormatter, priceFormatter, inventoryManage} = useContext(VehicleContext);
    const handleSearchChange = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };

    return (
        <>
            <section className='admin-common-wrap'>
                <div className='container'>
                    <div className='admin-black-box'>
                        <div className='d-flex align-items-center justify-content-between mb-4'>
                            <div className='md-title font-1-8em text-uppercase'>Lease Specials</div>
                            <div className='ad-search-block dash-search-block d-flex align-items-center'>
                                <input type='text' className='form-control' placeholder='Vehicle Search' value={searchText} onChange={handleSearchChange} />
                                <button className='dash-search-btn'>Search</button>
                            </div>
                        </div>
                        <AdminAccordionItem
                            getVehicleData={getVehicleData}
                            // getVehicleDescriptions={getVehicleDescriptions}
                            vehicleData={filteredVehicleData} 
                            numberFormatter={numberFormatter}
                            priceFormatter={priceFormatter}
                            inventoryManage={inventoryManage}
                        />
                    </div>
                </div>
            </section>
        </>
    )
}

export default Dashboard